import { fetchPractitionerEmployments } from '../services/fetchPractitionerEmployments';

export async function getEmploymentIdFromOrganizationId(organizationId: string, abortSignal: AbortSignal) {
    const practitionerEmployments = await fetchPractitionerEmployments(abortSignal);
    const result = practitionerEmployments.find((employment) => employment.organization.id === organizationId);

    if (!result) {
        throw new Error(`Employment not found for organization id: ${organizationId}`);
    }

    return result.id;
}
